<mat-toolbar color="primary" class="small-toolbar">
    <span>Tableau de bord</span>
</mat-toolbar>
<div>
    <ngx-widget-grid style="height: calc(100% - 64px);" [rows]="3" [columns]="3" [highlightNextPosition]="false" [showGrid]="true" (widgetPositionChange)="onWidgetChange($event)">
        <ngx-widget [(position)]="widgetPosition[0]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-contact-widget></app-contact-widget>
                </div>
            </div>
        </ngx-widget>
        <ngx-widget [(position)]="widgetPosition[1]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-problem-widget></app-problem-widget>
                </div>
            </div>
        </ngx-widget>
        <ngx-widget [(position)]="widgetPosition[2]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-medication-widget></app-medication-widget>
                </div>
            </div>
        </ngx-widget>
        <ngx-widget [(position)]="widgetPosition[3]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-protocol-widget></app-protocol-widget>
                </div>
            </div>
        </ngx-widget>
        <ngx-widget [(position)]="widgetPosition[4]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-labo-widget></app-labo-widget>
                </div>
            </div>
        </ngx-widget>
        <ngx-widget [(position)]="widgetPosition[5]" [movable]="widgetMovable" [resizable]="widgetResizable">
            <div style="height:100%;width:100%; display:flex;">
                <div style="height:100%;width:100%; padding:2px; background-color: rgb(185, 185, 185);">
                    <app-report-widget></app-report-widget>
                </div>
            </div>
        </ngx-widget>
    </ngx-widget-grid>    
</div>